'use strict';

logDecorator.$inject = ["$logProvider", "$provide", "config"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.logDecorator = logDecorator;
/*@ngInject*/
function logDecorator($logProvider, $provide, config) {
    // In acceptance and production, we only log warnings and errors
    $logProvider.debugEnabled(config.env === 'local' || config.env === 'dev');

    $provide.decorator('$log', ["$delegate", function ($delegate) {
        //Original methods
        var origInfo = $delegate.info;
        var origLog = $delegate.log;

        //Override the default behavior    
        $delegate.log = function () {
            if ($logProvider.debugEnabled()) {
                origLog.apply(null, arguments);
            }
        };

        //Override the default behavior
        $delegate.info = function () {
            if ($logProvider.debugEnabled()) {
                origInfo.apply(null, arguments);
            }
        };

        return $delegate;
    }]);
}


//////////////////
// WEBPACK FOOTER
// ./logDecorator.js
// module id = 258
// module chunks = 0